import { render, staticRenderFns } from "./courseSelector.vue?vue&type=template&id=489223f8&scoped=true&"
import script from "./courseSelector.vue?vue&type=script&lang=js&"
export * from "./courseSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489223f8",
  null
  
)

export default component.exports